<div class="package">
  <div class="package-container">
    <div class="package-header">
      <div class="package-pricing">
        <div class="crossed-price gilroy-m">
         {{ iscountryPK ? 'Rs ' : '$ ' }}  {{ (package?.actualPrice  | removeDecimal) || 0 }}
        </div>
        <div class="price gilroy-m">
     {{ iscountryPK ? 'Rs ' : '$ ' }}      {{ (package?.price |  removeDecimal) || 0 }}
        </div>
      </div>
      <div class="saving gilroy">
        <div>
          Save
        {{ iscountryPK ? 'Rs ' : '$ ' }}   {{ package?.savings | removeDecimal }}
        </div>
      </div>
    </div>
    <div class="package-content">
      <div class="gilroy-sb package-name">
        {{ package.name }}
      </div>
      <div class="gilroy package-description">
        {{ package.description }}
      </div>
    </div>
    <div class="package-items">
      @for (item of package?.packageProducts; track $index) {
        <div class="package-item">
          <div class="item-content">
            <div class="item-icon">
              <img src="assets/images/voice.svg" alt="" />
            </div>
            <div class="item-name gilroy">
              {{ item?.limit + " " + item?.name }}
            </div>
          </div>

          <!-- <div class="item-duration gilroy-sb">15 min</div> -->
        </div>
      }
    </div>
  </div>
  <div class="subscribe-button">
    <button class="gilroy" (click)="subscribePackage(package)">
      <div class="gilroy-m">Subscribe</div>
    </button>
  </div>
</div>
